module.exports = __webpack_public_path__ + "media/images/country_flags/is-8a026a24e74bfa9d45a314384b702e11.png";